import {useMutation} from '@tanstack/react-query'
import {noop} from 'lodash'
import {useCallback, useState} from 'react'

export const useWaiting = () => {
  const [resolvePromise, setResolvePromise] = useState<(value: unknown) => void>(noop)

  const [promise, setPromise] = useState<Promise<null>>(
    () =>
      new Promise((resolve) => {
        setResolvePromise(() => resolve)
      })
  )

  const finish = useCallback(() => {
    resolvePromise(null)
    setPromise(
      () =>
        new Promise((resolve) => {
          setResolvePromise(() => resolve)
        })
    )
  }, [resolvePromise])

  const readyMutation = useMutation({mutationFn: () => promise})
  const start = readyMutation.mutate

  return {
    finish,
    start,
  }
}
